import { css } from 'styled-components';

export const breakpoints = {
  xxs: 375,
  xs: 576,
  sm: 768,
  md: 991,
  lg: 992,
  xl: 1200,
  xxl: 1700,
};

export const mq = {
  xxs: `max-width:${(breakpoints.xxs || 1) - 1}px`,
  xs: `max-width: ${breakpoints.xs}px`,
  xsDown: `(max-width: ${breakpoints.xs - 1}px)`,
  smUp: `min-width: ${breakpoints.xs + 1}px`,
  sm: `min-width: ${breakpoints.xs + 1}px) and (max-width: ${breakpoints.sm}px`,
  smDown: `max-width: ${breakpoints.sm}px`,
  mdUp: `min-width: ${breakpoints.sm + 1}px`,
  md: `min-width: ${breakpoints.sm + 1}px) and (max-width: ${breakpoints.md}px`,
  mdDown: `max-width: ${breakpoints.md}px`,
  lgUp: `min-width: ${breakpoints.lg}px`,
  lg: `min-width: ${breakpoints.lg}px) and (max-width: ${breakpoints.xl - 1}px`,
  lgMax: `max-width: ${breakpoints.lg - 1}px`,
  lgDown: `max-width: ${breakpoints.xl - 1}px`,
  xl: `min-width: ${breakpoints.xl}px`,
  xxl: `min-width: ${breakpoints.xxl}px`,
  xxlDown: `(max-width: ${breakpoints.xxl - 1}px)`,
};

export const mediaQuery = {
  xxs: (...args) => css`
    @media (max-width: ${breakpoints.xxs}) {
      && {
        ${css(...args)}
      }
    }
  `,
  xs: (...args) => css`
    @media (max-width: ${breakpoints.xs}) {
      && {
        ${css(...args)}
      }
    }
  `,
  sm: (...args) => css`
    @media (max-width: ${breakpoints.sm}) {
      && {
        ${css(...args)}
      }
    }
  `,
  md: (...args) => css`
    @media (max-width: ${breakpoints.md}) {
      && {
        ${css(...args)}
      }
    }
  `,
  lg: (...args) => css`
    @media (max-width: ${breakpoints.lg}) {
      && {
        ${css(...args)}
      }
    }
  `,
  xl: (...args) => css`
    @media (max-width: ${breakpoints.xl}) {
      && {
        ${css(...args)}
      }
    }
  `,
  xxl: (...args) => css`
    @media (max-width: ${breakpoints.xxl}) {
      && {
        ${css(...args)}
      }
    }
  `,
};

export const containerWidth = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140,
};

/**
 * @constant
 * @type {number}
 */
export const gridGutter = 25;

/**
 * @constant
 * @type {number}
 */
export const gridGutterJobSearch = 0;

/**
 * @constant
 * @type {number}
 */
export const gridGutterHalf = gridGutter / 2;
